import { FC } from 'react';

import SunshineLoader from 'components/_core/SunshineLoader';

import { useTaxForecastData } from '../../hooks/useTaxForecastData';
import locales from '../../locales';
import EstimationCtaCard from '../EstimationCtaCard';
import CurrentEstimationOverview from './components/CurrentEstimationOverview';

const EstimationOverview: FC = () => {
  const {
    currentTaxForecastPeriodId,
    loading,
    taxForecastPeriods,
    taxForecastProfile,
  } = useTaxForecastData();

  const hasCustomizedEstimation =
    taxForecastProfile?.hasCustomizedEstimation &&
    Boolean(taxForecastPeriods?.length) &&
    currentTaxForecastPeriodId;

  if (loading) {
    return <SunshineLoader />;
  }

  return hasCustomizedEstimation ? (
    <CurrentEstimationOverview
      isSubjectToVAT={taxForecastProfile.isSubjectToVat}
      taxForecastPeriodId={currentTaxForecastPeriodId}
    />
  ) : (
    <EstimationCtaCard
      ctaText={locales.overview.empty.cta}
      subtitle={locales.overview.empty.subtitle}
      title={locales.overview.empty.title}
    />
  );
};

export default EstimationOverview;
